module.exports = __webpack_public_path__ + "static/media/romeu.378f08a2.jfif";